module.exports = __webpack_public_path__ + "static/img/3.e42f591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Accidentes-personales/3.png
// module id = uXRu
// module chunks = 0